import { render, staticRenderFns } from "./IndividualWorkGrid.vue?vue&type=template&id=3a5b13a0"
import script from "./IndividualWorkGrid.vue?vue&type=script&lang=js"
export * from "./IndividualWorkGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports